import { DumpJSON } from '@st/react-util/dump-json'
import { useProcess, useSelect } from '~/store'
import { selFolderState } from './st-folder-selectors'

export function StFolderViewerDebug() {
  const state = useSelect('stFolder', selFolderState)
  const stFolder = useProcess('stFolder')

  if (!state) {
    return null
  }

  return (
    <div className="flex h-full w-full flex-col">
      <DumpJSON
        onCopy={(text) => stFolder.send({ type: 'copyText', text })}
        value={{
          folderId: state.folderId,
          inputs: state.inputs,
          prevInputs: state.prevInputs,
          checklistItems: state.checklistItems,
          importJobId: state.folder.importJobId,
          sourceName: state.folder.sourceName,
          sourceId: state.folder.sourceId
        }}
      />
    </div>
  )
}
